<template>
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="100%"
        viewBox="0 0 512 512"
        enable-background="new 0 0 512 512"
        xml:space="preserve"
    >
        <path
            fill="#FF6720"
            opacity="1.000000"
            stroke="none"
            d="
M1.000000,184.000000
	C1.000000,123.030396 1.000000,62.060791 1.000000,1.045594
	C171.551224,1.045594 342.102448,1.045594 513.000000,1.045594
	C513.000000,61.687122 513.000000,122.374901 512.542175,183.641525
	C511.418518,184.236603 510.752655,184.267075 510.086823,184.267075
	C341.881042,184.269455 173.675278,184.270416 5.469497,184.258881
	C3.979658,184.258774 2.489831,184.090027 1.000000,184.000000
z"
        />
        <path
            fill="#FF6720"
            opacity="1.000000"
            stroke="none"
            d="
M513.000000,337.000000
	C513.000000,395.636932 513.000000,454.273895 513.000000,512.955444
	C342.449524,512.955444 171.899048,512.955444 1.000000,512.955444
	C1.000000,454.646240 1.000000,396.291779 1.468370,337.450806
	C58.055511,336.962067 114.174286,336.954010 170.293060,336.958923
	C284.528717,336.968933 398.764343,336.985901 513.000000,337.000000
z"
        />
        <path
            fill="#020201"
            opacity="1.000000"
            stroke="none"
            d="
M513.000000,336.531342
	C398.764343,336.985901 284.528717,336.968933 170.293060,336.958923
	C114.174286,336.954010 58.055511,336.962067 1.468370,336.982117
	C1.000000,286.312439 1.000000,235.624878 1.000000,184.468658
	C2.489831,184.090027 3.979658,184.258774 5.469497,184.258881
	C173.675278,184.270416 341.881042,184.269455 510.086823,184.267075
	C510.752655,184.267075 511.418518,184.236603 512.542175,184.110184
	C513.000000,234.687561 513.000000,285.375122 513.000000,336.531342
M309.477478,219.855957
	C309.477478,226.109344 309.477478,232.362717 309.477478,238.935486
	C295.018311,228.612411 279.238373,229.578140 269.330292,241.038361
	C259.532196,252.371429 260.037781,270.597473 270.442230,281.120667
	C281.022736,291.821930 297.033142,291.893982 310.005157,281.070770
	C310.139496,283.809387 310.263855,286.344727 310.394958,289.016968
	C313.618073,289.016968 316.533569,289.016968 319.604370,289.016968
	C319.604370,264.421112 319.604370,240.057693 319.604370,215.262848
	C317.216797,215.262848 315.069336,215.458466 312.972382,215.216324
	C309.940552,214.866196 309.118164,216.263290 309.477478,219.855957
M146.081894,250.774841
	C142.012787,265.894836 147.715317,279.974884 160.534698,286.460083
	C173.735413,293.138214 190.880081,287.381317 196.511719,274.110291
	C191.405472,274.172485 186.861359,273.513763 181.983276,276.948914
	C171.388535,284.409790 158.143066,278.188049 155.337021,264.955444
	C170.168823,264.955444 184.946960,264.955444 200.585541,264.955444
	C200.201996,260.559418 200.372025,256.364044 199.394531,252.455673
	C196.453201,240.695297 186.520111,232.556442 174.803040,231.729324
	C161.898178,230.818329 151.966187,237.203629 146.081894,250.774841
M416.710938,232.643814
	C412.422028,232.424210 408.054413,231.574829 403.858429,232.099106
	C389.323547,233.915192 378.069794,247.866333 379.335693,261.911530
	C380.687622,276.911255 392.415100,288.486786 406.964539,289.182404
	C422.073181,289.904755 435.208130,279.915314 437.866425,265.680786
	C440.597382,251.057434 432.495605,238.008713 416.710938,232.643814
M222.190659,244.646378
	C226.946228,240.426941 232.448364,239.908920 238.035690,242.202011
	C243.505539,244.446869 244.928009,249.481155 245.239319,254.888092
	C245.373154,257.212555 245.409973,259.545074 245.414978,261.874115
	C245.434235,270.831757 245.422791,279.789520 245.422791,289.000702
	C249.011368,289.000702 252.266342,289.000702 255.853149,289.000702
	C255.853149,287.355927 255.857040,285.890381 255.852539,284.424835
	C255.819748,273.771057 256.273590,263.087646 255.629333,252.470901
	C254.799408,238.794540 245.147308,230.544647 231.480713,231.853271
	C226.516785,232.328583 221.761490,234.983047 216.982529,236.618759
	C216.926437,236.189423 216.728165,234.672012 216.554703,233.344452
	C213.223480,233.344452 210.315079,233.344452 207.351471,233.344452
	C207.351471,252.075790 207.351471,270.476318 207.351471,288.949951
	C210.818954,288.949951 214.063675,288.949951 217.512283,288.949951
	C217.512283,279.001007 217.064713,269.328827 217.698364,259.727997
	C218.022247,254.820816 220.283569,250.041489 222.190659,244.646378
M333.495941,254.060883
	C337.427277,263.766113 341.493378,273.420654 345.179779,283.218018
	C345.946960,285.256836 345.895386,288.019043 345.202423,290.110352
	C343.448669,295.402740 341.115814,300.503235 338.851532,306.083344
	C340.417114,306.083344 341.443848,305.910187 342.390778,306.111847
	C348.008392,307.308075 350.326782,304.594788 352.334198,299.516144
	C360.458618,278.962402 369.117249,258.619904 377.563110,238.192963
	C378.212006,236.623581 378.739594,235.004089 379.463837,233.024490
	C377.536835,233.024490 376.338806,233.216553 375.225006,232.991699
	C370.023560,231.941666 367.732758,234.360809 366.040894,239.154037
	C361.867706,250.977280 357.101685,262.591278 352.143921,275.400574
	C346.523102,260.633087 341.293060,246.892288 336.089417,233.220886
	C332.345245,233.220886 328.920837,233.220886 325.091278,233.220886
	C327.863129,240.145462 330.510040,246.757965 333.495941,254.060883
M76.925308,215.924835
	C73.740150,215.656967 70.554993,215.389114 66.952957,215.086197
	C66.952957,221.471512 66.952957,227.072632 66.952957,233.148254
	C63.524891,233.148254 60.456516,233.148254 57.387772,233.148254
	C57.387772,236.563629 57.387772,239.480362 57.387772,242.881027
	C60.544960,242.881027 63.458763,242.881027 66.781158,242.881027
	C66.781158,252.670074 67.061508,261.979187 66.715767,271.264954
	C66.190971,285.359558 76.730103,291.025604 87.932709,288.858124
	C98.167976,286.877747 98.025322,287.022369 96.515755,276.785797
	C93.370949,277.764099 90.278458,279.049652 87.058105,279.654968
	C81.713219,280.659607 77.773087,278.170532 77.518669,272.825562
	C77.047050,262.917084 77.383614,252.970139 77.383614,242.647446
	C83.190170,242.647446 88.609840,242.647446 94.172523,242.647446
	C94.172523,239.303055 94.172523,236.360931 94.172523,232.852081
	C88.436424,232.852081 82.898087,232.852081 77.153679,232.852081
	C77.153679,227.136642 77.153679,221.987564 76.925308,215.924835
M105.899132,252.500397
	C105.899132,264.719940 105.899132,276.939484 105.899132,289.035278
	C109.797394,289.035278 112.928917,289.035278 116.492462,289.035278
	C116.492462,287.035797 116.487396,285.235931 116.493317,283.436096
	C116.521255,274.948883 116.401688,266.457611 116.631447,257.975830
	C116.804070,251.603592 119.337166,246.206436 125.244499,243.234207
	C130.782501,240.447784 135.113983,243.680954 139.276199,246.911224
	C139.370407,246.984329 139.559799,246.934799 140.135071,246.965256
	C141.779999,244.217346 143.527512,241.298065 145.328476,238.289490
	C140.936707,234.349670 136.332596,232.122513 130.702454,232.075775
	C124.954895,232.028076 120.561378,234.689423 116.709305,239.763062
	C116.471779,236.800781 116.329918,235.031525 116.192375,233.316223
	C112.659859,233.316223 109.417145,233.316223 105.899132,233.316223
	C105.899132,239.566177 105.899132,245.533386 105.899132,252.500397
M456.998047,268.499847
	C456.998047,250.896179 456.998047,233.292526 456.998047,215.507492
	C453.399292,215.507492 450.319122,215.507492 447.036469,215.507492
	C447.036469,240.129913 447.036469,264.518250 447.036469,289.046448
	C450.384094,289.046448 453.472565,289.046448 456.485657,289.046448
	C456.704102,288.571075 456.951477,288.282471 456.952972,287.992645
	C456.984619,281.828400 456.988647,275.664032 456.998047,268.499847
z"
        />
        <path
            fill="#F7F7F7"
            opacity="1.000000"
            stroke="none"
            d="
M309.478119,219.395203
	C309.118164,216.263290 309.940552,214.866196 312.972382,215.216324
	C315.069336,215.458466 317.216797,215.262848 319.604370,215.262848
	C319.604370,240.057693 319.604370,264.421112 319.604370,289.016968
	C316.533569,289.016968 313.618073,289.016968 310.394958,289.016968
	C310.263855,286.344727 310.139496,283.809387 310.005157,281.070770
	C297.033142,291.893982 281.022736,291.821930 270.442230,281.120667
	C260.037781,270.597473 259.532196,252.371429 269.330292,241.038361
	C279.238373,229.578140 295.018311,228.612411 309.477478,238.935486
	C309.477478,232.362717 309.477478,226.109344 309.478119,219.395203
M300.852905,243.397644
	C299.151306,242.748627 297.494965,241.917267 295.740326,241.482071
	C288.023895,239.568298 280.188568,242.788101 275.847717,249.533691
	C271.240662,256.692963 271.722656,266.261627 277.021179,272.829407
	C282.136780,279.170441 290.160797,281.601776 297.610931,278.752136
	C304.498566,276.117706 308.879028,271.051544 309.930267,263.714813
	C311.103973,255.523315 308.654877,248.601440 300.852905,243.397644
z"
        />
        <path
            fill="#F9F9F9"
            opacity="1.000000"
            stroke="none"
            d="
M146.210693,250.401703
	C151.966187,237.203629 161.898178,230.818329 174.803040,231.729324
	C186.520111,232.556442 196.453201,240.695297 199.394531,252.455673
	C200.372025,256.364044 200.201996,260.559418 200.585541,264.955444
	C184.946960,264.955444 170.168823,264.955444 155.337021,264.955444
	C158.143066,278.188049 171.388535,284.409790 181.983276,276.948914
	C186.861359,273.513763 191.405472,274.172485 196.511719,274.110291
	C190.880081,287.381317 173.735413,293.138214 160.534698,286.460083
	C147.715317,279.974884 142.012787,265.894836 146.210693,250.401703
M161.494385,244.891098
	C157.791229,247.963013 155.291138,251.671326 155.054993,256.713867
	C166.785446,256.713867 178.312607,256.713867 189.865753,256.713867
	C188.311127,243.025696 174.531342,237.054062 161.494385,244.891098
z"
        />
        <path
            fill="#F8F8F8"
            opacity="1.000000"
            stroke="none"
            d="
M417.099731,232.751968
	C432.495605,238.008713 440.597382,251.057434 437.866425,265.680786
	C435.208130,279.915314 422.073181,289.904755 406.964539,289.182404
	C392.415100,288.486786 380.687622,276.911255 379.335693,261.911530
	C378.069794,247.866333 389.323547,233.915192 403.858429,232.099106
	C408.054413,231.574829 412.422028,232.424210 417.099731,232.751968
M393.002350,271.311951
	C399.706879,279.713654 408.692932,282.178070 417.182831,277.943420
	C425.290741,273.899323 429.773560,264.372681 427.502472,255.727051
	C425.453430,247.926575 420.367920,242.951462 412.526855,241.378967
	C404.863251,239.842072 398.268463,242.388626 393.603424,248.686172
	C388.437653,255.659622 388.364716,263.136108 393.002350,271.311951
z"
        />
        <path
            fill="#F5F5F5"
            opacity="1.000000"
            stroke="none"
            d="
M221.929932,244.925385
	C220.283569,250.041489 218.022247,254.820816 217.698364,259.727997
	C217.064713,269.328827 217.512283,279.001007 217.512283,288.949951
	C214.063675,288.949951 210.818954,288.949951 207.351471,288.949951
	C207.351471,270.476318 207.351471,252.075790 207.351471,233.344452
	C210.315079,233.344452 213.223480,233.344452 216.554703,233.344452
	C216.728165,234.672012 216.926437,236.189423 216.982529,236.618759
	C221.761490,234.983047 226.516785,232.328583 231.480713,231.853271
	C245.147308,230.544647 254.799408,238.794540 255.629333,252.470901
	C256.273590,263.087646 255.819748,273.771057 255.852539,284.424835
	C255.857040,285.890381 255.853149,287.355927 255.853149,289.000702
	C252.266342,289.000702 249.011368,289.000702 245.422791,289.000702
	C245.422791,279.789520 245.434235,270.831757 245.414978,261.874115
	C245.409973,259.545074 245.373154,257.212555 245.239319,254.888092
	C244.928009,249.481155 243.505539,244.446869 238.035690,242.202011
	C232.448364,239.908920 226.946228,240.426941 221.929932,244.925385
z"
        />
        <path
            fill="#F8F8F8"
            opacity="1.000000"
            stroke="none"
            d="
M333.326447,253.715668
	C330.510040,246.757965 327.863129,240.145462 325.091278,233.220886
	C328.920837,233.220886 332.345245,233.220886 336.089417,233.220886
	C341.293060,246.892288 346.523102,260.633087 352.143921,275.400574
	C357.101685,262.591278 361.867706,250.977280 366.040894,239.154037
	C367.732758,234.360809 370.023560,231.941666 375.225006,232.991699
	C376.338806,233.216553 377.536835,233.024490 379.463837,233.024490
	C378.739594,235.004089 378.212006,236.623581 377.563110,238.192963
	C369.117249,258.619904 360.458618,278.962402 352.334198,299.516144
	C350.326782,304.594788 348.008392,307.308075 342.390778,306.111847
	C341.443848,305.910187 340.417114,306.083344 338.851532,306.083344
	C341.115814,300.503235 343.448669,295.402740 345.202423,290.110352
	C345.895386,288.019043 345.946960,285.256836 345.179779,283.218018
	C341.493378,273.420654 337.427277,263.766113 333.326447,253.715668
z"
        />
        <path
            fill="#F9F9F9"
            opacity="1.000000"
            stroke="none"
            d="
M77.039490,216.381653
	C77.153679,221.987564 77.153679,227.136642 77.153679,232.852081
	C82.898087,232.852081 88.436424,232.852081 94.172523,232.852081
	C94.172523,236.360931 94.172523,239.303055 94.172523,242.647446
	C88.609840,242.647446 83.190170,242.647446 77.383614,242.647446
	C77.383614,252.970139 77.047050,262.917084 77.518669,272.825562
	C77.773087,278.170532 81.713219,280.659607 87.058105,279.654968
	C90.278458,279.049652 93.370949,277.764099 96.515755,276.785797
	C98.025322,287.022369 98.167976,286.877747 87.932709,288.858124
	C76.730103,291.025604 66.190971,285.359558 66.715767,271.264954
	C67.061508,261.979187 66.781158,252.670074 66.781158,242.881027
	C63.458763,242.881027 60.544960,242.881027 57.387772,242.881027
	C57.387772,239.480362 57.387772,236.563629 57.387772,233.148254
	C60.456516,233.148254 63.524891,233.148254 66.952957,233.148254
	C66.952957,227.072632 66.952957,221.471512 66.952957,215.086197
	C70.554993,215.389114 73.740150,215.656967 77.039490,216.381653
z"
        />
        <path
            fill="#FBFBFB"
            opacity="1.000000"
            stroke="none"
            d="
M105.899132,252.000488
	C105.899132,245.533386 105.899132,239.566177 105.899132,233.316223
	C109.417145,233.316223 112.659859,233.316223 116.192375,233.316223
	C116.329918,235.031525 116.471779,236.800781 116.709305,239.763062
	C120.561378,234.689423 124.954895,232.028076 130.702454,232.075775
	C136.332596,232.122513 140.936707,234.349670 145.328476,238.289490
	C143.527512,241.298065 141.779999,244.217346 140.135071,246.965256
	C139.559799,246.934799 139.370407,246.984329 139.276199,246.911224
	C135.113983,243.680954 130.782501,240.447784 125.244499,243.234207
	C119.337166,246.206436 116.804070,251.603592 116.631447,257.975830
	C116.401688,266.457611 116.521255,274.948883 116.493317,283.436096
	C116.487396,285.235931 116.492462,287.035797 116.492462,289.035278
	C112.928917,289.035278 109.797394,289.035278 105.899132,289.035278
	C105.899132,276.939484 105.899132,264.719940 105.899132,252.000488
z"
        />
        <path
            fill="#FBFBFB"
            opacity="1.000000"
            stroke="none"
            d="
M456.998047,268.999756
	C456.988647,275.664032 456.984619,281.828400 456.952972,287.992645
	C456.951477,288.282471 456.704102,288.571075 456.485657,289.046448
	C453.472565,289.046448 450.384094,289.046448 447.036469,289.046448
	C447.036469,264.518250 447.036469,240.129913 447.036469,215.507492
	C450.319122,215.507492 453.399292,215.507492 456.998047,215.507492
	C456.998047,233.292526 456.998047,250.896179 456.998047,268.999756
z"
        />
        <path
            fill="#030303"
            opacity="1.000000"
            stroke="none"
            d="
M301.158630,243.617371
	C308.654877,248.601440 311.103973,255.523315 309.930267,263.714813
	C308.879028,271.051544 304.498566,276.117706 297.610931,278.752136
	C290.160797,281.601776 282.136780,279.170441 277.021179,272.829407
	C271.722656,266.261627 271.240662,256.692963 275.847717,249.533691
	C280.188568,242.788101 288.023895,239.568298 295.740326,241.482071
	C297.494965,241.917267 299.151306,242.748627 301.158630,243.617371
z"
        />
        <path
            fill="#060606"
            opacity="1.000000"
            stroke="none"
            d="
M161.782410,244.656860
	C174.531342,237.054062 188.311127,243.025696 189.865753,256.713867
	C178.312607,256.713867 166.785446,256.713867 155.054993,256.713867
	C155.291138,251.671326 157.791229,247.963013 161.782410,244.656860
z"
        />
        <path
            fill="#030303"
            opacity="1.000000"
            stroke="none"
            d="
M392.799500,270.994080
	C388.364716,263.136108 388.437653,255.659622 393.603424,248.686172
	C398.268463,242.388626 404.863251,239.842072 412.526855,241.378967
	C420.367920,242.951462 425.453430,247.926575 427.502472,255.727051
	C429.773560,264.372681 425.290741,273.899323 417.182831,277.943420
	C408.692932,282.178070 399.706879,279.713654 392.799500,270.994080
z"
        />
    </svg>
</template>

<script>
export default {
    name: "TrendyolIcon",
    props: {},
};
</script>

<style scoped></style>
